declare global {
    interface Window {
        debounceTimer: any;
        updateNotification: any;
    }
}

export const debounce = (fn: Function, delay: number = 800) => {
    return function (this: any, ...args: any[]) {
        if (window.debounceTimer) {
            clearTimeout(window.debounceTimer);
        }
        window.debounceTimer = setTimeout(() => {
            fn.apply(this, args);
        }, delay);
    };
}
